/**
 * Leave a previous-message edit. Escape and a click outside the box both
 * cancel, including when focus has moved into the document.
 * Open menus and dialogs get the key or click first.
 */

export const CHAT_MESSAGE_EDITING_SELECTOR = '[data-chat-message-editing]'

const OPEN_CHROME_SELECTOR = [
  '[data-autocomplete-menu]',
  '[data-radix-popper-content-wrapper]',
  '[data-slot="dropdown-menu-content"][data-state="open"]',
  '[data-slot="popover-content"][data-state="open"]',
  '[data-slot="select-content"][data-state="open"]',
  '[role="menu"][data-state="open"]',
  '[role="listbox"][data-state="open"]',
  '[data-slot="dialog-content"]',
  '[data-slot="dialog-overlay"]',
  '[data-slot="markdown-image-lightbox"]',
].join(',')

export function isChatMessageEditOpen(): boolean {
  if (typeof document === 'undefined') return false
  return Boolean(document.querySelector(CHAT_MESSAGE_EDITING_SELECTOR))
}

/** True when Escape should close a menu or dialog instead of the edit. */
export function shouldDeferChatMessageEditEscape(): boolean {
  if (typeof document === 'undefined') return false
  return Boolean(document.querySelector(OPEN_CHROME_SELECTOR))
}

/**
 * True when this pointer target is outside the edit composer.
 * Portaled menus, dialogs, and the lightbox stay inside the edit session.
 */
export function shouldDismissChatMessageEdit(
  target: EventTarget | null,
  editRoot: HTMLElement | null,
): boolean {
  if (!(target instanceof Node)) return false
  if (editRoot?.contains(target)) return false
  if (target instanceof Element && target.closest(OPEN_CHROME_SELECTOR)) return false
  return true
}
